import { lsGet, safeAwait } from 'utils/request'

export const getVenderById = (id) => {
  return safeAwait(lsGet(`/venders/${id}`))
}
